import { render } from "./AssetDetailView.vue?vue&type=template&id=797199b9&scoped=true"
import script from "./AssetDetailView.vue?vue&type=script&lang=js"
export * from "./AssetDetailView.vue?vue&type=script&lang=js"

import "./AssetDetailView.vue?vue&type=style&index=0&id=797199b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-797199b9"]])

export default __exports__